import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaAtom, FaShieldAlt, FaTint, FaLeaf, FaBolt, FaFlask } from 'react-icons/fa';
import h2Image from '../assets/images/h2.png';
import fuelWaterHybridImage from '../assets/images/fuel-water-hybrid.png';
import hidrogenPastaImage from '../assets/images/hidrogen-pasta.png';
import hidrofitImage from '../assets/images/hidrofit.png';
import {
  HomeWrap, Hero, HeroLeft, HeroTag, HeroTitle, HeroDesc, HeroBtns, BtnSolid, BtnGhost,
  HeroRight, HeroVisual,
  StatsBar, StatsInner, StatItem,
  QuoteSection, QuoteInner,
  ProductsSection, ProductsInner, Label, SectionH2, SectionSub, ProductGrid, ProductCard,
  BenefitSection, BenefitInner, BenefitList, BenefitItem, BenefitVisual, BenefitStat,
  VideoSection, VideoInner, VideoGrid, VideoItem, VideoWrap, VideoLabel,
  GuaranteeSection, GuaranteeInner,
} from './HomeStyles';

const stats = [
  { value: '1,600+', label: 'Peneliti Dunia' },
  { value: '1,000+', label: 'Artikel Ilmiah' },
  { value: '170+',   label: 'Penyakit Teratasi' },
  { value: '50+',    label: 'Tahun Penelitian' },
];

const products = [
  {
    num: '01',
    img: hidrofitImage,
    title: 'hidrofit⁺',
    desc: 'Inovasi hidrogen untuk kesehatan tubuh: terapi uap, mandi, dan air minum anti oksidan terbaik.',
    to: '/hidrofit',
  },
  {
    num: '02',
    img: hidrogenPastaImage,
    title: 'HIDROGENPASTA',
    desc: 'Efisiensi listrik industri hingga 50% dengan garansi uang kembali 100% jika tidak terbukti.',
    to: '/hidrogenpasta',
  },
  {
    num: '03',
    img: fuelWaterHybridImage,
    title: 'FUEL WATER HYBRID',
    desc: 'Sistem hybrid air-bahan bakar. Hemat BBM minimal 30%, potensi efisiensi hingga 70%.',
    to: '/fuel-water-hybrid',
  },
];

const benefits = [
  { icon: <FaAtom />,     title: 'Anti Oksidan Terbaik',  desc: 'Molekul H₂ terkecil, menembus sel lebih cepat dan efektif dari vitamin manapun.' },
  { icon: <FaShieldAlt />, title: 'Selektif & Aman',       desc: 'Hanya aktif melawan radikal bebas berbahaya. Toksisitas rendah, aman seumur hidup.' },
  { icon: <FaTint />,     title: '170+ Penyakit',          desc: 'Didukung 1000+ jurnal kedokteran internasional dan 1600+ peneliti terkemuka dunia.' },
  { icon: <FaLeaf />,     title: 'Ramah Lingkungan',       desc: 'Teknologi bersih berbasis air. Tidak menghasilkan limbah berbahaya bagi lingkungan.' },
  { icon: <FaBolt />,     title: 'Efisiensi Energi',       desc: 'Hemat BBM 30%+ dan listrik industri hingga 50% dengan teknologi hidrogen terapan.' },
  { icon: <FaFlask />,    title: 'Riset 50+ Tahun',        desc: 'Teknologi yang telah terbukti dan teruji selama lebih dari 50 tahun penelitian global.' },
];

export default function Home() {
  const productRef = useRef(null);

  return (
    <HomeWrap>

      {/* ── HERO ── */}
      <div style={{ background: '#03045e' }}>
        <Hero>
          <HeroLeft>
            <HeroTag>Teknologi Hidrogen Indonesia</HeroTag>
            <HeroTitle>
              Energi Bersih.<br />
              Hidup <em>Sehat.</em><br />
              Masa Depan.
            </HeroTitle>
            <HeroDesc>
              Solusi inovatif berbasis hidrogen untuk kesehatan, efisiensi energi,
              dan kehidupan berkelanjutan yang lebih baik bagi seluruh keluarga Indonesia.
            </HeroDesc>
            <HeroBtns>
              <BtnSolid onClick={() => productRef.current?.scrollIntoView({ behavior: 'smooth' })}>
                Lihat Produk
              </BtnSolid>
              <BtnGhost as={Link} to="/kontak">
                Hubungi Kami
              </BtnGhost>
            </HeroBtns>
          </HeroLeft>

          <HeroRight>
            <HeroVisual>
              <img src={h2Image} alt="H2 Molecule" />
            </HeroVisual>
          </HeroRight>
        </Hero>
      </div>

      {/* ── STATS ── */}
      <StatsBar>
        <StatsInner>
          {stats.map((s, i) => (
            <StatItem key={i}>
              <h3>{s.value}</h3>
              <p>{s.label}</p>
            </StatItem>
          ))}
        </StatsInner>
      </StatsBar>

      {/* ── QUOTE ── */}
      <QuoteSection>
        <QuoteInner>
          <div className="mark" />
          <p>
            Air kaya hidrogen tidak hanya memiliki ribuan testimoni, tapi merupakan
            satu-satunya produk kesehatan yang didukung ratusan jurnal kedokteran terkemuka
            di dunia. Diteliti lebih dari 1600 peneliti, lebih dari 1000 artikel ilmiah,
            dapat menyembuhkan lebih dari 170 penyakit, dan terbukti aman dikonsumsi
            oleh semua kalangan lebih dari 50 tahun.
          </p>
          <cite>Molecular Hydrogen Institute</cite>
        </QuoteInner>
      </QuoteSection>

      {/* ── PRODUCTS ── */}
      <ProductsSection ref={productRef}>
        <ProductsInner>
          <Label>Produk Unggulan</Label>
          <SectionH2>Tiga Inovasi<br />Terdepan Kami</SectionH2>
          <SectionSub>
            Rangkaian produk berbasis teknologi hidrogen yang telah terbukti
            memberikan manfaat nyata bagi kehidupan Anda.
          </SectionSub>

          <ProductGrid>
            {products.map((p, i) => (
              <ProductCard key={i} as={Link} to={p.to} style={{ textDecoration: 'none' }}>
                <span className="num">{p.num}</span>
                <img src={p.img} alt={p.title} />
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
                <span className="arrow">→</span>
              </ProductCard>
            ))}
          </ProductGrid>
        </ProductsInner>
      </ProductsSection>

      {/* ── BENEFITS ── */}
      <BenefitSection>
        <BenefitInner>
          <div>
            <Label>Keunggulan H₂</Label>
            <SectionH2>Mengapa<br />Hidrogen?</SectionH2>
            <SectionSub>
              Anti oksidan terbaik yang pernah ada, didukung sains
              dan penelitian global selama lebih dari 50 tahun.
            </SectionSub>
            <BenefitList>
              {benefits.map((b, i) => (
                <BenefitItem key={i}>
                  <div className="icon">{b.icon}</div>
                  <div>
                    <h4>{b.title}</h4>
                    <p>{b.desc}</p>
                  </div>
                </BenefitItem>
              ))}
            </BenefitList>
          </div>

          <BenefitVisual>
            {[
              { value: '30%+', label: 'Hemat Bahan Bakar' },
              { value: '50%',  label: 'Hemat Listrik Industri' },
              { value: '0',    label: 'Emisi Gas Buang' },
              { value: '130',  label: 'Oktan Bahan Bakar' },
            ].map((s, i) => (
              <BenefitStat key={i}>
                <h3>{s.value}</h3>
                <p>{s.label}</p>
              </BenefitStat>
            ))}
          </BenefitVisual>
        </BenefitInner>
      </BenefitSection>

      {/* ── VIDEOS ── */}
      <VideoSection>
        <VideoInner>
          <Label>Video</Label>
          <SectionH2>Lihat<br />Buktinya</SectionH2>
          <VideoGrid>
            <VideoItem>
              <VideoWrap>
                <iframe
                  title="Water Treatment Plant"
                  src="https://www.youtube.com/embed/_VG60lZFEgk"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen loading="lazy"
                />
              </VideoWrap>
              <VideoLabel>
                <div className="info">
                  <h4>Water Treatment Plant</h4>
                  <p>Mengubah Air Laut Menjadi Air Minum</p>
                </div>
                <span className="num">01</span>
              </VideoLabel>
            </VideoItem>
            <VideoItem last>
              <VideoWrap>
                <iframe
                  title="TiiS Cooling"
                  src="https://www.youtube.com/embed/0VKXUc_GPho"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen loading="lazy"
                />
              </VideoWrap>
              <VideoLabel>
                <div className="info">
                  <h4>TiiS Cooling System</h4>
                  <p>Teknologi Nano Membran Hidrogen</p>
                </div>
                <span className="num">02</span>
              </VideoLabel>
            </VideoItem>
          </VideoGrid>
        </VideoInner>
      </VideoSection>

      {/* ── GUARANTEE ── */}
      <GuaranteeSection>
        <GuaranteeInner>
          <span className="badge">Garansi Uang Kembali</span>
          <h2>Terbukti atau<br />Uang Kembali</h2>
          <p>
            Setelah alat terpasang langsung dapat dirasakan penghematan beban listrik
            minimal 10% dan bertahap terus bertambah seiring pemakaian hingga lebih dari 30%.
          </p>
          <a
            href="/assets/media/HIDROGEN.id.pdf"
            download="HIDROGEN.id.pdf"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              padding: '15px 36px',
              background: '#ffffff',
              color: '#7f0000',
              borderRadius: '4px',
              fontWeight: 800,
              fontSize: '0.95rem',
              letterSpacing: '0.5px',
              marginTop: '1rem',
              transition: 'all 0.25s ease',
            }}
          >
            ⬇ Download Hidrogen
          </a>
        </GuaranteeInner>
      </GuaranteeSection>

    </HomeWrap>
  );
}
